import React, { useState, useEffect, useRef } from 'react';
import { Alerta, Botao, Box, Card, Col, Row, TipoAlerta } from '@intechprev/componentes-web';
import { Page } from '..';
import { Content } from './styles';

export const RendaMonitorada: React.FC = ({
  ...props
}) => {
  const page = useRef<Page>(null);

  const [AlertText, setAlertText] = useState<string>("");

  useEffect(() => {
    (async () => {
      try {
        //...
      }
      catch (e) {
        const error = e.response ? e.response.data : e;
        setAlertText(error);
      }

    })();
  }, []);

  return (
    <Page {...props} ref={page}>
      <Box titulo={"Beneficiários"}>
        <Row>
          <Col>
            <Card titulo={""}>
              <Content>
                {"Propiciar o gerenciamento analítico previdenciário de rendas futuras."}
              </Content>
            </Card>
          </Col>

          <Col>
            <Card titulo={""}>
              <Content>
                {"Permitir projeções futuras de saldo de conta e benefícios decorrentes, segundo a aplicação de premissas e hipóteses atuariais e financeiras."}
              </Content>
            </Card>
          </Col>
        </Row>
      </Box>

      <Alerta tipo={TipoAlerta.danger}
        mensagem={AlertText}
      />

      <a href="http://rendamonitorada.com.br/rm/#" target="_blank" className="btn btn-primary btn-block">Clique aqui para acessar o Renda Monitorada</a>

    </Page>
  );

}